import React, { useState, useRef,useEffect } from "react";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import "./Profile.css";
import { useQuery } from "react-query";
import { toLowerCase, toUpperCase, capitalizeFirstLetter } from "../../../../page/UserRegister/Register.jsx";
import { classNames } from "primereact/utils";
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from "primereact/dialog";
import ResetPassword from "./ResetPassword.jsx"; 
import { useUser } from "../../../../Context/UserContext.js";
import { useSecteur } from "../../../../Context/SecteurContext.js";
import { Form, Field } from "react-final-form";
import fetchSecteur from "../../../../Data/secteur_service.js";
import fetchFonction from "../../../../Data/fonction_service.js";
import { useFonction } from "../../../../Context/FonctionContext.js";
import { baseURL, instance } from "../../../../api";
import { data } from "jquery";
import { isGexMemeber } from "../../navBar";
import { useClient } from "../../../../Context/ClientContext";

export const adminGex = (user) => { return user.id_utilisateur_gexpertise; };

export default function Profile() { 
  const { user, setUserAttributes } = useUser();
  const { fonctions, setFonctionAttributes } = useFonction();
  const { secteurs, setSecteurAttributes } = useSecteur();
  const toast = useRef(null);
  const [file, setFile] = useState();
  const [photo, setPhoto] = useState();
  const [openDialogReset, setDialogReset] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
    const [isMember, setIsMember] = useState(false);
    const {client , selectedClient}=useClient()
  
  const clientTableau = Object.values(client);
  
  
  const checkAdminRole = () => {
    if (!selectedClient || !clientTableau.length) {
      setIsAdmin(false);
      setIsMember(false);
      return;
    }
  // Find the selected client's roles
    const clientData = clientTableau.find(
      (client) => client.id_client_gexpertise === selectedClient
    );
  
    if (clientData && clientData.role && clientData.role.toLowerCase() === "utilisateur") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
    setIsMember(isGexMemeber(user));
  
  };
  
  useEffect(() => {
    checkAdminRole();
  }, [selectedClient, clientTableau]);
  useEffect(() => {
    console.log("ClientTableau:", clientTableau);
    console.log("SelectedClient:", selectedClient);
    console.log("Is Admin?", isAdmin);
    console.log("Is GexMember?", isMember);
  
  }, [isAdmin, isMember,selectedClient, clientTableau]);

  useQuery('fonction', () => fetchFonction(setFonctionAttributes));
  useQuery('secteur', () => fetchSecteur(setSecteurAttributes));

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return (
      isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>
    );
  };
  const [openDialogInfo, setOpenDialogInfo] = useState(false); // State to manage dialog visibility
const [message, setMessage] = useState(""); // State to store the user's message

const handleOpenDialogInfo = () => {
  setOpenDialogInfo(true); // Open the dialog
};


// juste au-dessus du composant Profile
const secteurIdToLibelle = (user, secteurs) => {
  // si déjà un libellé côté user
  if (user?.secteur_activite && typeof user.secteur_activite === "string") {
    return user.secteur_activite;
  }
  // sinon, mapper l'id -> libellé via le contexte
  if (user?.id_secteur_activite && secteurs && typeof secteurs === "object") {
    const match = Object.values(secteurs).find(
      s => s?.id_secteur_activite_gexpertise === user.id_secteur_activite
    );
    if (match?.libelle) return match.libelle;
  }
  return "";
};


const showToast = (severity, summary, detail) => {
  if (toast.current) {
      toast.current.show({ severity, summary, detail, life: 3000 });
  }
};



  // Updated handleClick function using async/await and PrimeReact Toast
  const handleSendMessage = async () => {
    try {
      // Ensure data is available (e.g., from form state)
      const formData = {
        prenom: user?.prenom ? user?.prenom : "",
        nom: user?.nom ? user?.nom : "",
        nomSociete: user?.entreprise ? user?.entreprise : "",
        tel_fixe: user?.tel_fixe ? user?.tel_fixe : "",
        tel_mobile: user?.tel_mobile ? user?.tel_mobile : "",
        intitule_poste: user?.intitule_poste ? user?.intitule_poste : "",
        type_fonction: user.id_type_fonction ? user.id_type_fonction : "",
        //secteur_activite: user.id_secteur_activite ? user.id_secteur_activite : "",
        secteur_activite: secteurIdToLibelle(user, secteurs),
              
        email: user?.email || "" ,
        message: message // Include the message field
        // Add email here
      };
     
  
      // Send the request with formData
      // Send the request with JSON data
    const response = await instance.post(`/api/utilisateurs/demande-modification-credentials`, formData, {
      headers: {
        'Content-Type': 'application/json' ,// Ensure the correct header is set
        
      }
    });
    console.log("Data being sent to the API:", formData);

  
    if (response.status === 200) {
      toast.current.show({
        severity: "success",
        summary: "Succès",
        detail: "Demande envoyée avec succès.",
        life: 2000,
      });
      setMessage("");
      setOpenDialogInfo(false);
    }
  } catch (error) {
    console.error("Error sending the message:", error);
    toast.current.show({
      severity: "error",
      summary: "Erreur",
      detail: "Échec de l'envoi de la demande. Veuillez réessayer.",
      life: 2000,
    });
    // Close the dialog
    
  }

 
};
  {/*{const validate = (data) => { 
    let errors = {}; 
    if (!data.nom) { errors.nom = "nom requis."; }
    if (!data.prenom) { errors.prenom = "prenom requis."; }
    if (!data.type_fonction && (!adminGex(user))) {
      errors.type_fonction = "type de fonction requis.";
    }
    if (!data.secteur_activite && (!adminGex(user))) {
      errors.secteur_activite = "secteur d'activite requis.";
    }
    return errors;
  };*/}
  // remplace ta validate par ceci (exemple)
const validate = (data) => {
  const errors = {};

  // Champs affichés mais disabled: ne les rends pas "requis" si l'utilisateur ne peut pas les modifier

  if (!data.prenom && !document.getElementById('prenom')?.disabled) {
    errors.prenom = "prenom requis.";
  }

  // Exiger seulement si le champ est visible et éditable
  const typeFonctionFieldRendered = false; // tu l'as commenté => false
  if (!adminGex(user) && typeFonctionFieldRendered && !data.type_fonction) {
    errors.type_fonction = "type de fonction requis.";
  }

  // secteur_activite (InputText affiché si !adminGex && role !== 'GaxAdmin' && !isMember)
  const secteurVisible = (!adminGex(user) && user?.role !== 'GaxAdmin' && !isMember);
  if (secteurVisible && !data.secteur_activite?.trim()) {
    errors.secteur_activite = "secteur d'activité requis.";
  }

  // civilité (si affichée)
  const civiliteVisible = !isMember;
  if (civiliteVisible && !data.civilite) {
    errors.civilite = "civilité requise.";
  }

  return errors;
};


  const OnSubmit = async (data) => { 
    console.log('Données du formulaire soumises :', data);
    const formData = new FormData();
    formData.append("nom", data.nom);
    formData.append("prenom", data.prenom);
    formData.append("entreprise", data.nomSociete);
    formData.append("intitule_poste", data.intitule_poste);
    formData.append("tel_fixe", data.tel_fixe);
    formData.append("tel_mobile", data.tel_mobile);
    formData.append("preference_vue", data.preference_vue);
    //formData.append("type_fonction", data.type_fonction);
    formData.append("secteur_activite", data.secteur_activite)
    formData.append("email", data.email);
    formData.append('civilite',data.civilite)
    //formData.append("photo", photo);

    try {
      console.log("Sending FormData:", formData);
      const response = await instance.post(`/api/utilisateurs/utilisateur`, formData);
      if (response.status === 200) {
        toast.current.show({
          severity: 'success',
          summary: 'Succès',
          detail: 'Le profil est mis à jour',
          life: 2000
        });
        setUserAttributes(response.data);
      } else {
        console.error("Unexpected response:", response);
        toast.current.show({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Une erreur est survenue lors de la mise à jour du profil',
          life: 3000
        });
      }
    } catch (error) {
      console.error("Error details:", error.response ? error.response.data : error.message);
      toast.current.show({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Une erreur est survenue lors de la mise à jour du profil',
        life: 3000
      });
    }
  };

  const PasswordReset = () => { setDialogReset(true); };

  const secteurTab = Object.entries(secteurs).map((item) => {
    const [key, value] = item;
    return { name: value.libelle, value: value.id_secteur_activite_gexpertise };
  });

  const fonctionTab = Object.entries(fonctions).map((item) => {
    const [key, value] = item;
    return { name: value.libelle, value: value.id_type_fonction_gexpertise };
  });

  return (
    <div className="profile-Side" id="profilForm">
      <Toast ref={toast} />
      {user && (
        <Card className="profilInformation">
          <Form
            onSubmit={OnSubmit}
            initialValues={{
              prenom: user?.prenom ? user?.prenom : "",
              nom: user?.nom ? user?.nom : "",
              nomSociete: user?.entreprise ? user?.entreprise : "",
              tel_fixe: user?.tel_fixe ? user?.tel_fixe : "",
              tel_mobile: user?.tel_mobile ? user?.tel_mobile : "",
              intitule_poste: user?.intitule_poste ? user?.intitule_poste : "",
              //type_fonction: user.id_type_fonction ? user.id_type_fonction : "",
              //secteur_activite: user.id_secteur_activite ? user.id_secteur_activite : "",
              secteur_activite: secteurIdToLibelle(user, secteurs),

              preference_vue: user?.preference_vue || "Vue cartographie",
              civilite: user?.civilite ? user?.civilite : "",
              email: user?.email || ""  // Add email here
            }}
            validate={validate}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit} className="p-fluid">
                <div className="p-fluid grid profileField">
                  {/* First Row */}
                  <div className="field col-md-4 col-sm-4">
                    <Field
                      format={toUpperCase}
                      parse={toUpperCase}
                      name="nom"
                      render={({ input, meta }) => (
                        <div className="p-field">
                          <span className="p-float-label p-input-icon-right">
                            <InputText
                              id="nom"
                              disabled={true}
                              {...input}
                              className={classNames({ "p-invalid": isFormFieldValid(meta) })}
                            />
                            <label
                              htmlFor="nom"
                              className={classNames({ "p-error": isFormFieldValid(meta) })}
                            >
                              Nom*
                            </label>
                          </span>
                          {getFormErrorMessage(meta)}
                        </div>
                      )}
                    />
                  </div>

                  <div className="field col-md-4 col-sm-4">
                    <Field
                      format={capitalizeFirstLetter}
                      parse={capitalizeFirstLetter}
                      name="prenom"
                      render={({ input, meta }) => (
                        <div className="p-field">
                          <span className="p-float-label p-input-icon-right">
                            <InputText
                              id="prenom"
                              disabled={true}
                              {...input}
                              className={classNames({ "p-invalid": isFormFieldValid(meta) })}
                            />
                            <label
                              htmlFor="prenom"
                              className={classNames({ "p-error": isFormFieldValid(meta) })}
                            >
                              Prénom*
                            </label>
                          </span>
                          {getFormErrorMessage(meta)}
                        </div>
                      )}
                    />
                  </div>

                  <div className="field col-md-4 col-sm-4">
                  
                    <Button
                      type="button"
                      label="Cliquer ici pour toute demande de modification"
                      icon="pi pi-envelope"
                      className="p-button-outlined"
                      style={{
                        border: "none",
                        color: "inherit",
                        backgroundColor: "transparent",
                        marginBottom:"10px",
                      }}
                      onClick={handleOpenDialogInfo} 
                    />
                   
            
                  </div>
                
                </div>

                <div className="p-fluid grid profileField">
                  {/* Second Row */}
                  {/*{adminGex(user) ? (
                    <Field
                      name="type_fonction"
                      render={({ input }) => (
                        <input
                          type="hidden"
                          {...input}
                          value={user.id_type_fonction ? user.id_type_fonction : ""}
                        />
                      )}
                    />
                  ) : (
                    <div className="field col-md-6 col-sm-4">
                      <Field
                        name="type_fonction"
                        render={({ input, meta }) => (
                          <div className="p-field">
                            <span className="p-float-label p-input-icon-right">
                              <Dropdown
                                id="type_fonction"
                                options={fonctionTab}
                                optionLabel="name"
                                {...input}
                                className={classNames({ "p-invalid": isFormFieldValid(meta) })}
                              />
                              <label
                                htmlFor="type_fonction"
                                className={classNames({ "p-error": isFormFieldValid(meta) })}
                              >
                                Type de Fonction
                              </label>
                            </span>
                            {getFormErrorMessage(meta)}
                          </div>
                        )}
                      />
                    </div>
                  )}*/}
                {!isMember && (
                <div className="field col-md-6 col-sm-12">
                  <Field
                    name="civilite"
                    render={({ input, meta }) => (
                      <div className="p-field">
                        <span className="p-float-label">
                          <Dropdown
                            id="civilite"
                            value={input.value} 
                            hidden={user.id_utilisateur_gexpertise ? true : false}
                            onChange={(e) => input.onChange(e.value)} 
                            options={[
                              { label: "Madame", value: "Madame" },
                              { label: "Monsieur", value: "Monsieur" },
                              { label: "Autre", value: "Autre" },
                            ]}
                            placeholder="Choisissez votre civilité"
                            className={classNames({
                              "p-invalid": isFormFieldValid(meta),
                            })}
                          />
                          <label
                            htmlFor="civilite"
                            hidden={user.id_utilisateur_gexpertise ? true : false}
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                          >
                            Civilité*
                          </label>
                        </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}
                  />
                </div>)}
                </div>
                
               
                <div className="p-fluid grid profileField">
                  {/* Third Row */}
                   {!isMember && (
                  <div className="field col-md-4 col-sm-4">
                    <Field
                      name="tel_fixe"
                      render={({ input, meta }) => (
                        <div className="p-field">
                          <span className="p-float-label p-input-icon-right">
                            <InputText
                              id="tel_fixe"
                              disabled={adminGex(user)}
                              {...input}
                              className={classNames({ "p-invalid": isFormFieldValid(meta) })}
                            />
                            <label
                              htmlFor="tel_fixe"
                              className={classNames({ "p-error": isFormFieldValid(meta) })}
                            >
                              Téléphone fixe
                            </label>
                          </span>
                          {getFormErrorMessage(meta)}
                        </div>
                      )}
                    />
                  </div>)}

                  <div className="field col-md-4 col-sm-4">
                    {!isMember && (
                    <Field
                      name="tel_mobile"
                      render={({ input, meta }) => (
                        <div className="p-field">
                          <span className="p-float-label p-input-icon-right">
                            <InputText
                              id="tel_mobile"
                              disabled={adminGex(user)}
                              {...input}
                              className={classNames({ "p-invalid": isFormFieldValid(meta) })}
                            />
                            <label
                              htmlFor="tel_mobile"
                              className={classNames({ "p-error": isFormFieldValid(meta) })}
                            >
                              Téléphone mobile
                            </label>
                          </span>
                          {getFormErrorMessage(meta)}
                        </div>
                      )}
                    />)}
                  </div>

                  <div className="field col-md-4 col-sm-4">
                    {!isMember && (
                    <Field
                      format={toLowerCase}
                      parse={toLowerCase}
                      name="nomSociete"
                      render={({ input, meta }) => (
                        <div className="p-field">
                          <span className="p-float-label p-input-icon-right">
                            <InputText
                              id="nomSociete"
                              disabled={adminGex(user)}
                              {...input}
                              className={classNames({ "p-invalid": isFormFieldValid(meta) })}
                            />
                            <label
                              htmlFor="nomSociete"
                              className={classNames({ "p-error": isFormFieldValid(meta) })}
                            >
                              Nom de la Société
                            </label>
                          </span>
                          {getFormErrorMessage(meta)}
                        </div>
                      )}
                    />)}
                  </div>
                </div>

                <div className="p-fluid grid profileField">
                  {/* Fourth Row */}
                 
                  {!adminGex(user) && user?.role !== 'GaxAdmin' && !isMember && (
                    <div className="field col-md-4 col-sm-4">
                      <Field
  name="secteur_activite"
  format={(v) => secteurIdToLibelle({ secteur_activite: v, id_secteur_activite: v }, secteurs)}
  parse={(v) => v}
  render={({ input, meta }) => (
    <div className="p-field">
      <span className="p-float-label p-input-icon-right">
        <InputText
          id="secteur_activite_text"
          value={input.value || ""}
          onChange={(e) => input.onChange(e.target.value)}
          placeholder="Ex. Banque, Industrie, Santé…"
          className={classNames({ "p-invalid": meta.touched && meta.error })}
        />

        {/* Dropdown — écrit aussi le libellé (name), pas l'id */}
        

                              <label
                                htmlFor="secteur_activite"
                                className={classNames({ "p-error": isFormFieldValid(meta) })}
                              >
                                Secteur d'activité
                              </label>
                            </span>
                            {getFormErrorMessage(meta)}
                          </div>
                        )}
                      />
                    </div>
                  )}
                  {!isMember && (
                  <div className="field col-md-4 col-sm-4">
                   
                    <Field
                      name="intitule_poste"
                      render={({ input, meta }) => (
                        <div className="p-field">
                          <span className="p-float-label p-input-icon-right">
                            <InputText
                              id="intitule_poste"
                              disabled={adminGex(user)}
                              
                              {...input}
                              className={classNames({ "p-invalid": isFormFieldValid(meta) })}
                            />
                            <label
                              htmlFor="intitule_poste"
                              className={classNames({ "p-error": isFormFieldValid(meta) })}
                            >
                              Intitule poste
                            </label>
                          </span>
                          {getFormErrorMessage(meta)}
                        </div>
                      )}
                    />
                  </div>)}
                  
             
                  <div className="field col-md-4 col-sm-4">
    <Field
      name="email"
      render={({ input, meta }) => (
        <div className="p-field">
          <span className="p-float-label p-input-icon-right">
            <InputText
              id="email"
              disabled={true}
              {...input}
              className={classNames({ "p-invalid": isFormFieldValid(meta) })}
            />
            <label
              htmlFor="email"
              className={classNames({ "p-error": isFormFieldValid(meta) })}
            >
              Email
            </label>
          </span>
          {getFormErrorMessage(meta)}
        </div>
      )}
    />
                 </div>
                 </div>
                 <Dialog
            visible={openDialogReset}
            style={{ width: "50vw" }}
            header="Réinitialisation du mot de passe"
            onHide={(e) => setDialogReset(false)}
          >
            <ResetPassword
       setDialogReset={setDialogReset}
       showToast={showToast} // Pass the toast callback
    />
          </Dialog>
                 

                <div className="field col-md-4 col-sm-4">
                  <button
                    type="button"
                    className="resetPass text-center"
                    onClick={() => setDialogReset(true)}
                    style={{ fontSize: "14px", color: "gray" }}
                  >
                    Changer de mot de passe
                  </button>
                </div>

                {/* Leave "Préférence d'affichage des actifs" as it is */}
                <div>
                  <h4> Préférence d'affichage des actifs</h4>
                  <span className="p-float-label">
                    <Field
                      name="preference_vue"
                      render={({ input, meta }) => (
                        <div className="p-field">
                          <span className="p-float-label p-input-icon-right">
                            <Dropdown
                              id="preference_vue"
                              options={['Vue cartographie', 'Vue Liste']}
                              value={input.value || 'Vue cartographie'}
                              {...input}
                              className={classNames({ "p-invalid": isFormFieldValid(meta) })}
                            />
                            <label
                              htmlFor="preference_vue"
                              className={classNames({ "p-error": isFormFieldValid(meta) })}
                            ></label>
                          </span>
                          {getFormErrorMessage(meta)}
                        </div>
                      )}
                    />
                  </span>
                </div>

                <div className="row">
                  <Button
                    className="btn-sauvegarde"
                    label="Sauvegarder les modifications"
                    type="submit"
                  />
                </div>
                <Dialog
  visible={openDialogInfo}
  style={{ width: "50vw" }}
  header={`Demande modification des informations d'utilisateur : ${user?.prenom} ${user?.nom}`}
  onHide={() => setOpenDialogInfo(false)}
>
  <div className="p-fluid">
    
    <div className="p-field">
      <label htmlFor="message">Message</label>
      <InputText
        id="message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Écrivez votre message ici"
        style={{ width: "100%" }}
      />
    </div>
    <div style={{ textAlign: "right", marginTop: "20px"}}>
      <Button
        label="Envoyer"
        //icon="pi pi-send"
        className="p-mt-2 send"
        onClick={handleSendMessage}
      />
    </div>
  </div>
</Dialog>


              </form>
            )}
          />
        </Card>
      )}
      

      <Dialog
  visible={openDialogInfo}
  style={{ width: "50vw" }}
  header={`Demande modification des informations d'utilisateur : ${user?.prenom} ${user?.nom}`}
  onHide={() => setOpenDialogInfo(false)} // Close the dialog when clicking outside or the close button
>
  <div className="p-fluid">
    <div className="p-field">
      <label htmlFor="message">Message</label>
      <InputText
        id="message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Écrivez votre message ici"
        style={{ width: "100%" }}
      />
    </div>
    <div style={{ textAlign: "right", marginTop: "20px" }}>
      <Button
        label="Envoyer"
        className="p-mt-2 send"
        onClick={async () => {
          await handleSendMessage();
          setOpenDialogInfo(false); // Close the dialog after sending the message
        }}
      />
    </div>
  </div>
</Dialog>

    </div>
  );
}
